import {
  TOGGLE_HOME,
  TOGGLE_ABOUT,
  TOGGLE_LOADING,
  TOGGLE_SCIENCE,
  SET_ACTIVE_MENUS,
  RESET_SECTOR_MENU,
  SET_BIOLOGICAL_RESULT,
  SET_MARINE_ENERGY_RESULT,
  SET_BTM_DATAHUB_ACTIVE_PANEL,
  SET_BTM_DATAHUB_ACTIVE_MOMENT,
  SET_BTM_BLUEGROWTH_ACTIVE_PANEL,
  SET_HINDCAST_DATA,
  SET_BTM_TOOLS_ACTIVE_PANEL,
  SET_BTM_TOOLS_ACTIVE_TOOL,
  SET_ACTIVE_PRODUCT,
  SET_ACTIVE_DEVICE,
  SET_BLUEGROWTH_OPERATIVITY_INPUTS
} from "./types";

export default {
  toggleHome(context, visibility) {
    context.commit(TOGGLE_HOME, visibility);
  },
  toggleAbout(context, visibility) {
    context.commit(TOGGLE_ABOUT, visibility);
  },
  toggleScience(context, visibility) {
    context.commit(TOGGLE_SCIENCE, visibility);
  },
  resetSectorMenu(context) {
    context.commit(RESET_SECTOR_MENU);
  },
  setActiveMenus(context, payload) {
    context.commit(SET_ACTIVE_MENUS, payload);
  },
  toggleLoading(context, visibility) {
    context.commit(TOGGLE_LOADING, visibility);
  },
  updateBiologicalResult(context, payload) {
    const biologicalResult = {
      coords: payload.params.point,
      specie: payload.params.specie,
      dates: payload.params.dates,
      index: payload.index
    };
    context.commit(SET_BIOLOGICAL_RESULT, biologicalResult);
  },
  updateMarineEnergyResult(context, payload) {
    const marineEnergyResult = {
      coords: payload.params.point,
      dates: payload.params.dates,
      config: payload.params.config,
      index: payload.index
    };
    context.commit(SET_MARINE_ENERGY_RESULT, marineEnergyResult);
  },
  updateHindcastDataResults(context, hindcastDataResult) {
    context.commit(SET_HINDCAST_DATA, hindcastDataResult);
  },
  setBTMDataHubActivePanel(context, panel) {
    context.commit(SET_BTM_DATAHUB_ACTIVE_PANEL, panel);
  },
  setBTMDataHubActiveMoment(context, moment) {
    context.commit(SET_BTM_DATAHUB_ACTIVE_MOMENT, moment);
  },
  setBTMBlueGrowthActivePanel(context, panel) {
    context.commit(SET_BTM_BLUEGROWTH_ACTIVE_PANEL, panel);
  },
  setBTMToolsActivePanel(context, panel) {
    context.commit(SET_BTM_TOOLS_ACTIVE_PANEL, panel);
  },
  setBTMToolsActiveTool(context, tool) {
    context.commit(SET_BTM_TOOLS_ACTIVE_TOOL, tool);
  },
  setActiveProduct(context, product) {
    context.commit(SET_ACTIVE_PRODUCT, product);
  },
  setActiveDevice(context, device) {
    context.commit(SET_ACTIVE_DEVICE, device);
  },
  setBluegrowthOperativityInputs(context, payload) {
    context.commit(SET_BLUEGROWTH_OPERATIVITY_INPUTS, payload);
  }
};
